module.exports = __webpack_public_path__ + "img/color-painting-palette.9c22a057.svg";